@if (!AccessAllowed && CompletedLoading) {
  <div>
    <h3 style="border: 2px solid;border-radius: 6px;position: absolute;top: 50%;left: 50%;transform: translate(-50%, -50%);padding: 10px;">You don't have access to this function</h3>
  </div>
}

@if (AccessAllowed) {
  <div class="p-3">
    <div style="margin-bottom: 12px; text-align: right;">
      <button pButton type="button" class="p-button-outlined p-button-sm" style="height: 34px;" (click)="goBack()">
        <span class="pi pi-chevron-left" style="margin-right: 6px;"></span>
        <span>Back to At a Glance</span>
      </button>
    </div>
    <div class="text-900 font-medium text-xl mb-3"><h3>New Customer Bookings
    </h3></div>
    <p class="m-0 mb-4 p-0 text-600 line-height-3 mr-3">
      <span class="pi pi-info-circle" style="margin-right:2px;"></span>
      This list shows all new bookings made by customers.  Please click the green thumbs up to clear this booking from the list, you can also view the booking by clicking on the eye button.  This does not have any effect on the booking it is just a way for you to see new bookings/check them if you wish and clear the list ready for the next bookings.
    </p>
    <div class="surface-card p-4 shadow-2 border-round">
      @if (ListBookings == null || ListBookings.length == 0) {
        <div style="width:100%">
          <p style="text-align:center; font-size:20px;">There are currently no bookings to acknowledge</p>
        </div>
      }
      @if (ListBookings && ListBookings.length > 0) {
        <p-table
          [value]="ListBookings" sortField="startTime"
          responsiveLayout="scroll">
          <ng-template #header>
            <tr>
              <th style="padding: 7px;" width="1%">
                &nbsp;
              </th>
              <th pSortableColumn="bookingId">Sales ID
                <p-sorticon [field]="bookingIdHR"></p-sorticon>
              </th>
              <th style="text-align:center" pSortableColumn="startTime">Start Date/Time
                <p-sorticon [field]="startTime"></p-sorticon>
              </th>
              <th pSortableColumn="name">Name
                <p-sorticon [field]="name"></p-sorticon>
              </th>
              <th pSortableColumn="packageName">Package
                <p-sorticon [field]="packageName"></p-sorticon>
              </th>
              <th pSortableColumn="guests">Guests
                <p-sorticon [field]="guests"></p-sorticon>
              </th>
              <th style="text-align: center;" pSortableColumn="outstanding">Total<br>O/S
                <p-sorticon [field]="outstanding"></p-sorticon>
              </th>
              <th style="padding: 3px;" width="1%"></th>
              <th style="padding: 3px;" width="1%"></th>
            </tr>
          </ng-template>
          <ng-template #body let-data>
            @if (!data.inProgress && !inProgress) {
              <tr [ngStyle]="{'background-color': (data.disabled==true) ? '#fee' : '#ffffff'}" onmouseover="this.originalstyle=this.style.backgroundColor;this.style.backgroundColor='#dddddd'" onmouseout="this.style.backgroundColor=this.originalstyle;" [ngStyle]="{'background-color': (data.disabled==true) ? '#fee' : '#ffffff'}">
                <td style="padding: 7px;">
                  @if (data.publicBooking) {
                    <div class="pi pi-user"></div>
                  }
                  @if (data.extraslist != '' && data.extraslist != null) {
                    <div class="pi pi-star-fill"></div>
                  }
                  @if (data.allergy != '' && data.allergy != null) {
                    <div class="pi pi-asterisk"></div>
                  }
                  @if (data.notes != '' && data.notes != null) {
                    <div style="color:red" class="pi pi-exclamation-circle"></div>
                  }
                </td>
                <td>{{data.bookingIdHR}}</td>
                <td style="text-align: center;">
                  <div>{{data.startTime | date:'dd/MM/yy'}}</div>
                  <div>{{data.startTime | date:'HH:mm' : 'UTC'}}</div>
                </td>
                <td>{{data.name}}</td>
                <td>{{data.packageName}}</td>
                <td>{{data.guests}}</td>
                <td>
                  <div style="text-align: center;">{{data.total | currency: CurrencySymbol}}</div>
                  @if (data.outstanding <=0) {
                    <div style="text-align: center;">
                      {{data.outstanding | currency: CurrencySymbol}}
                    </div>
                  }
                  @if (data.outstanding > 0) {
                    <div style="text-align: center;">
                      <span style="color: Red; font-weight: bold;">{{data.outstanding | currency: CurrencySymbol}}</span>
                    </div>
                  }
                </td>
                <td style="padding: 3px;">
                  <button pButton type="button" pTooltip="View Booking" class="p-button-sm p-element p-ripple p-button-info p-button p-component" (click)="viewBooking(data.bookingId)">
                    <span class="pi pi-eye"></span>
                  </button>
                </td>
                <td style="padding: 3px;">
                  @if (!data.acknowledged && data.disabled!=true) {
                    <button pButton type="button" pTooltip="Acknowledge" class="p-button-sm p-element p-ripple p-button-success p-button p-component" (click)="acknowledge(data.bookingId)">
                      <span class="pi pi-thumbs-up"></span>
                    </button>
                  }
                </td>
              </tr>
            }
          </ng-template>
        </p-table>
      }
    </div>
  </div>
}
